// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__17Gog","label":"Section_label__1CtpM","contentWrap":"Section_contentWrap__2TyEM","footer":"Section_footer__OfJpN","footerInner":"Section_footerInner__-99vV"};